
      if (
        !(
          navigator.userAgent.includes("Electron") ||
          navigator.userAgent.includes("Cypress") ||
          import.meta.env.MODE === "test"
        )
      ) {
        window.AppcuesSettings = {
          enableURLDetection: true,
        };
        const script = document.createElement("script");
        script.src = "//fast.appcues.com/106479.js";
        script.async = true;
        script.setAttribute("nonce", "__NONCE__");
        document.head.appendChild(script);
      }
    